import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  MiddleSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '17px',
    alignItems: 'center'
  },
  mainSection: {
    background: theme.palette.grey[100],
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 8
  },
  upSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  inputs: {
    display: 'flex',
    width: '60%',
    flexDirection: 'column',
    padding: '17px',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  mainTimePeriodForm: {
    width: '40%',
    paddingRight: '17px',
    marginTop: '4px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: '0px',
      paddingRight: '17px',
      paddingLeft: '17px'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },

  dateText: {
    margin: '7px',
    paddingLeft: '6px'
  },
  mainDateRow: {
    marginTop: '15px'
  },
  downSection: {
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto'
    }
  },
  midSection: {
    display: 'flex',
    alignItems: 'center'
  },
  hideZerosFromPriceContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '11px'
  },
  currencyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 5
  },
  menuItemRight: {
    direction: 'ltr'
  },
  inventoryTypeSelector: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minHeight: 100
  },
  inventoryTypeSelectorLabel: {
    marginLeft: 30,
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      marginRight: 59
    }
  },
  inventoryTypeRadioGroup: {
    display: 'flex',
    flexDirection: 'row'
  },
  refreshButton: {
    marginRight: 10
  }
}))

export default useStyles
